import React, { useContext, useEffect, useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import { Link, useHistory, useLocation } from 'react-router-dom';
import {
    Row,
    Col,
    Card,
    Table,
    Modal,
    Button,
    ProgressBar,
} from "react-bootstrap";
import Moment from 'react-moment';
import swal from "sweetalert";
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactPaginate from "react-paginate";
import { getAppliedLeaveListData, AddAppliedLeaveData, updateAppliedLeaveData, updateLeaveStatusData, removeLeaveData, getLeaveTypeData } from '../../../store/actions/LeaveAction';
import { globalLoadingAction } from '../../../store/actions/GlobalAction';


const AppliedLeave = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const startDateRef = useRef();
    const endDateRef = useRef();

    let errorsObj = { type: '', startDate: '', endDate: '' };
    const [errors, setErrors] = useState(errorsObj);

    const [type, setType] = useState('');
    const [description, setDescription] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [recId, setRecId] = useState(null);
    const [action, setAction] = useState(0);
    const [addModal, setAddModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [details, setDetails] = useState(null);

    //filter
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(10);

    useEffect(() => {
        dispatch(globalLoadingAction(true));
        dispatch(getLeaveTypeData(props.history));
        dispatch(getAppliedLeaveListData(1, perPage));
    }, []);

    const onAddProjectHandler = () => {
        setAction(1);
        setType('');
        setDescription('')
        setRecId(null);
        setStartDate(null);
        setEndDate(null);
        setAddModal(true);
        setErrors(errorsObj);
    }

    const onEditHandler = (item) => {
        console.log(item)
        let start_date = item?.start_date ? new Date(item.start_date) : new Date();
        let end_date = item?.end_date ? new Date(item.end_date) : new Date();
        setRecId(item._id);
        setDescription(item.description);
        setAction(2);
        setType(item.leave_type);
        setStartDate(start_date);
        setEndDate(end_date);
        setAddModal(true);
        setErrors(errorsObj);
    }

    const onCleanHandler = () => {
        setPageNo(1);
        dispatch(globalLoadingAction(true));
        dispatch(getAppliedLeaveListData(1, perPage, props.history));
    }

    const handlePageClick = (data) => {
        setPageNo(data.selected + 1);
        dispatch(globalLoadingAction(true));
        dispatch(getAppliedLeaveListData(data.selected + 1, perPage, props.history));
    };





    const onSubmitHandler = () => {
        let error = false;
        const errorObj = { ...errorsObj };

        if (type === '') {
            errorObj.type = 'Leave type is Required';
            error = true;
        }

        if (startDate === null) {
            errorObj.startDate = 'Start Date is Required';
            error = true;
        }
        if (endDate === null) {
            errorObj.endDate = 'End Date is Required';
            error = true;
        }

        setErrors(errorObj);
        if (error) {
            return;
        }
        setLoading(true);
        if (action == 1) {
            dispatch(AddAppliedLeaveData(type, startDate ? moment(startDate).format("YYYY-MM-DD") : '', endDate ? moment(endDate).format("YYYY-MM-DD") : '', description, ListCallBack, props.history));
        } else {
            dispatch(updateAppliedLeaveData(recId, type, startDate ? moment(startDate).format("YYYY-MM-DD") : '', endDate ? moment(endDate).format("YYYY-MM-DD") : '', description, ListCallBack, props.history));
        }
    }

    const onStatusHandler = (status) => {
        dispatch(globalLoadingAction(true));
        dispatch(updateLeaveStatusData(details?._id, status, ListCallBack));
        setViewModal(false)
    }

    const ListCallBack = () => {
        setLoading(false);
        dispatch(globalLoadingAction(true));
        dispatch(getAppliedLeaveListData(pageNo, perPage, props.history));
        setAddModal(false);
    }

    const onDeleteHandler = (id) => {

        swal({
            title: "Are you sure?",
            text:
                "You want to remove this item !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(removeLeaveData(id, deleteCallback, props.history));
            }
        })
    }

    const deleteCallback = () => {
        if (props.leaveList.length > 1) {
            dispatch(getAppliedLeaveListData(pageNo, perPage, props.history));
        } else {
            if (pageNo == 1) {
                dispatch(getAppliedLeaveListData(1, perPage, props.history));
                setPageNo(1);
            } else {
                dispatch(getAppliedLeaveListData(pageNo - 1, perPage, props.history));
                setPageNo(pageNo - 1);
            }

        }
    }

    const onViewHandler = (item) => {
        setDetails(item);
        setViewModal(true)
    }

    return (
        <>
            <div className="row">
                <div className="breadcrumb-container">
                    <ul>
                        <li>
                            <Link to={"#"}>Leave Management</Link>
                        </li>
                        <li><i className="fa fa-angle-right"></i></li>
                        <li>
                            <Link to={"#"}>Applied Leave</Link>
                        </li>
                    </ul>
                </div>

                <div className="title-body-container">
                    <div className="title-body">
                        <h3>Applied Leave</h3>
                        <p>Maintain user information - Add, edit, delete and invite users</p>
                    </div>
                    <div className="title-filter-container">
                        {!props.systemAdmin ?
                            <div className="button-filter">
                                <button className="add-user-btn"
                                    onClick={() => onAddProjectHandler()}><i class="fa fa-plus" aria-hidden="true"></i></button>
                            </div> : null}

                    </div>

                </div>
                <div className="account-setting-content">
                    <Col lg={12}>
                        <Card>
                            <Card.Body>
                                {props.screenVisible ?
                                    <>
                                        {props.leaveList.length > 0 ?
                                            <Table responsive>
                                                <thead>
                                                    <tr>
                                                        {props.systemAdmin ?
                                                            <th>
                                                                <strong>Emp Name</strong>
                                                            </th> : null}
                                                        <th>
                                                            <strong>Leave Type</strong>
                                                        </th>
                                                        <th>
                                                            <strong>Start Date</strong>
                                                        </th>
                                                        <th>
                                                            <strong>End Date</strong>
                                                        </th>
                                                        <th>
                                                            <strong>Create Date</strong>
                                                        </th>
                                                        <th>
                                                            <strong>Status</strong>
                                                        </th>
                                                        <th>
                                                            <strong>Actions</strong>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        props.leaveList.map((item, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    {props.systemAdmin ?
                                                                        <td>{`${item.first_name} ${item.last_name}`}</td> : null}
                                                                    <td>{item.leave_type_title}</td>
                                                                    <td><Moment format="D MMM YYYY" withTitle>{item.start_date}</Moment></td>
                                                                    <td><Moment format="D MMM YYYY" withTitle>{item.end_date}</Moment></td>
                                                                    <td><Moment format="D MMM YYYY" withTitle>{item.created_at}</Moment></td>
                                                                    <td>
                                                                        {props.systemAdmin ?
                                                                            <Button
                                                                                className="btn-xs"
                                                                                variant={item.status == 0 ? "warning" : item.status == 1 ? "success" : "danger"}
                                                                            >
                                                                                {item.status == 0 ? "Pending" : item.status == 1 ? "Approved" : "Reject"}
                                                                            </Button> :
                                                                            <Button
                                                                                className="btn-xs"
                                                                                variant={item.status == 0 ? "warning" : item.status == 1 ? "success" : "danger"}
                                                                            >
                                                                                {item.status == 0 ? "Applied" : item.status == 1 ? "Approved" : "Reject"}
                                                                            </Button>}
                                                                    </td>

                                                                    <td>
                                                                        <div className="d-flex">
                                                                            {props.systemAdmin ?
                                                                                <Button
                                                                                    className="btn btn-info btn-xs me-1"
                                                                                    onClick={() => onViewHandler(item)}
                                                                                >
                                                                                    Details
                                                                                </Button> :
                                                                                <>
                                                                                    <Link
                                                                                        onClick={() => onEditHandler(item)}
                                                                                        className="btn btn-warning shadow btn-xs sharp me-1"
                                                                                    >
                                                                                        <i className="fas fa-pencil-alt"></i>
                                                                                    </Link>

                                                                                    <Button
                                                                                        className="btn btn-danger shadow btn-xs sharp me-1"
                                                                                        onClick={() => onDeleteHandler(item._id)}
                                                                                    >
                                                                                        <i className="fa fa-trash"></i>
                                                                                    </Button>
                                                                                </>}

                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                            :
                                            <div className="nodata-found-view">
                                                <h2>Data not found</h2>
                                                <p>Applied Leave is empty</p>
                                                <button type="button" onClick={onCleanHandler}>
                                                    Retry
                                                </button>
                                            </div>
                                        }
                                    </>
                                    : null}

                                <div className="pagination-container">
                                    {parseInt(props.totalRecord) > 0 && props.showLoading == false ? (
                                        <div className="page-result alignResult">
                                            <p>Showing{" "}{(pageNo - 1) * perPage + 1 + " - " + ((pageNo - 1) * perPage + props.leaveList.length) + " of " + "( " + props.totalRecord + " items )"}</p>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}

                                    {parseInt(props.totalRecord) > 10 ? (
                                        <ReactPaginate
                                            containerClassName="pagination-gutter false pagination-circle pagination"
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            breakLabel="..."
                                            nextLabel={<i class="fa fa-angle-right" aria-hidden="true"></i>}
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            previousLabel={<i class="fa fa-angle-left" aria-hidden="true"></i>}
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            renderOnZeroPageCount={null}
                                            activeClassName="active"
                                            onPageChange={handlePageClick}
                                            pageRangeDisplayed={3}
                                            pageCount={props.totalPage}
                                            //initialPage={active - 1}
                                            forcePage={pageNo - 1}
                                        />
                                    ) : null}
                                </div>

                            </Card.Body>
                        </Card>
                    </Col>
                </div>


                <Modal
                    className="fade bd-example-modal-sm"
                    size="md"
                    show={addModal}
                >
                    <div className="add-user-modal-form-view">
                        <div className="modal-title-view">
                            <h3>{action == 1 ? "Add" : "Update"} Leave</h3>
                        </div>
                        <div className="basic-form">

                            <div className="row">

                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        Start Date
                                    </label>
                                    <div className="form-calendar">
                                        <DatePicker
                                            ref={startDateRef}
                                            selected={startDate}
                                            className="form-control"
                                            placeholderText=""
                                            onChange={(date) => setStartDate(date)}
                                        />
                                        <button type='button' className="form-calendar-btn"
                                            onClick={() => startDateRef.current.setOpen(true)}
                                        >
                                            <i class="fa-regular fa-calendar-days"></i>
                                        </button>
                                    </div>
                                    {errors.startDate && <div className="text-danger fs-12">{errors.startDate}</div>}
                                </div>

                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        End Date
                                    </label>
                                    <div className="form-calendar">
                                        <DatePicker
                                            ref={endDateRef}
                                            selected={endDate}
                                            className="form-control"
                                            placeholderText=""
                                            onChange={(date) => setEndDate(date)}
                                        />
                                        <button type='button' className="form-calendar-btn"
                                            onClick={() => endDateRef.current.setOpen(true)}
                                        >
                                            <i class="fa-regular fa-calendar-days"></i>
                                        </button>
                                    </div>
                                    {errors.endDate && <div className="text-danger fs-12">{errors.endDate}</div>}
                                </div>

                                <div className="form-group form-group-modal-custom mb-3 col-12">
                                    <label className="mb-1">
                                        Leave type
                                    </label>
                                    <div className="select-drop-down">
                                        <span><i class="fa fa-angle-down"></i></span>
                                        <select
                                            class="form-control select-control"
                                            value={type}
                                            onChange={(e) => setType(e.target.value)}>
                                            <option></option>
                                            {
                                                props.leaveType.map((item, index) => {
                                                    return <option key={index} value={item._id}>{item.title}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    {errors.type && <div className="text-danger fs-12">{errors.type}</div>}
                                </div>
                                <div className="form-group form-group-modal-custom mb-3 col-12">
                                    <label className="mb-1">
                                        Description
                                    </label>
                                    <input className="form-control" value={description} onChange={(e) => setDescription(e.target.value)} />
                                </div>

                            </div>

                            <div className="modal-button-group mt-4">
                                <button type="button" onClick={() => setAddModal(false)} className="btn form-cencel-btn">
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary role-form-btn" onClick={() => onSubmitHandler()}>
                                    {action == 1 ? "Submit" : "Update"} {" "}
                                    {loading ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        : null}
                                </button>

                            </div>

                        </div>

                    </div>
                </Modal>


                <Modal
                    className="fade bd-example-modal-sm"
                    size="md"
                    show={viewModal}
                >
                    <div className="add-user-modal-form-view">
                        <div className="modal-title-view">
                            <h3>Leave Details</h3>
                        </div>
                        <div className="basic-form">

                            <div className="row">
                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        Employee Name
                                    </label>
                                    <input className="form-control" value={details?.first_name + " " + details?.last_name} disabled />
                                </div>
                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        Leave type
                                    </label>
                                    <input className="form-control" value={details?.leave_type_title} disabled />
                                </div>
                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        Start Date
                                    </label>
                                    <input className="form-control" value={details?.start_date ? moment(details?.start_date).format("MM/DD/YYYY") : ''} disabled />
                                </div>
                                <div className="form-group form-group-modal-custom mb-3 col-6">
                                    <label className="mb-1">
                                        End Date
                                    </label>
                                    <input className="form-control" value={details?.end_date ? moment(details?.end_date).format("MM/DD/YYYY") : ''} disabled />
                                </div>
                                <div className="form-group form-group-modal-custom mb-3 col-12">
                                    <label className="mb-1">
                                        Description
                                    </label>
                                    <input className="form-control" value={details?.description} disabled />
                                </div>

                            </div>

                            <div className="modal-button-group mt-4">
                                <button type="button" onClick={() => setViewModal(false)} className="btn form-cencel-btn custom-btn-default">
                                    Close
                                </button>
                                <button type="button" onClick={() => onStatusHandler(2)} className="btn form-cencel-btn custom-btn-danger">
                                    Reject
                                </button>
                                <button type="button" onClick={() => onStatusHandler(1)} className="btn form-cencel-btn custom-btn-success">
                                    Approve
                                </button>

                            </div>

                        </div>

                    </div>
                </Modal>


            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        screenVisible: state.leave.screenVisible,
        showLoading: state.leave.showLoading,
        leaveList: state.leave.leaveList,
        totalPage: state.leave.totalLeavePage,
        totalRecord: state.leave.totalLeaveRecord,
        systemAdmin: state.auth.systemAdmin,
        userType: state.auth.userType,
        leaveType: state.leave.leaveType,
    };
};
export default connect(mapStateToProps)(AppliedLeave);